/* tslint:disable */
/* eslint-disable */
/**
 * Speechmatics ASR REST API
 * The Speechmatics Automatic Speech Recognition REST API is used to submit ASR jobs and receive the results. The supported job type is transcription of audio files.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@speechmatics.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Properties of the language pack.
 * @export
 * @interface LanguagePackInfo
 */
export interface LanguagePackInfo {
  /**
   * Full descriptive name of the language, e.g. \'Japanese\'.
   * @type {string}
   * @memberof LanguagePackInfo
   */
  language_description?: string;
  /**
   * The character to use to separate words.
   * @type {string}
   * @memberof LanguagePackInfo
   */
  word_delimiter: string;
  /**
   * The direction that words in the language should be written and read in.
   * @type {string}
   * @memberof LanguagePackInfo
   */
  writing_direction?: LanguagePackInfoWritingDirectionEnum;
  /**
   * Whether or not ITN (inverse text normalization) is available for the language pack.
   * @type {boolean}
   * @memberof LanguagePackInfo
   */
  itn?: boolean;
  /**
   * Whether or not language model adaptation has been applied to the language pack.
   * @type {boolean}
   * @memberof LanguagePackInfo
   */
  adapted?: boolean;
}

export const LanguagePackInfoWritingDirectionEnum = {
  LeftToRight: 'left-to-right',
  RightToLeft: 'right-to-left',
} as const;

export type LanguagePackInfoWritingDirectionEnum =
  (typeof LanguagePackInfoWritingDirectionEnum)[keyof typeof LanguagePackInfoWritingDirectionEnum];
